import { PageState } from 'models/PageState';
import { SiteMode } from 'models/SiteMode';

export const getSiteMode = (state: PageState) => state.appShell.siteMode;
export const selectIsCompanyMode = (state: PageState) =>
  state.appShell.siteMode === SiteMode.Company;

export const getSalesTaker = (state: PageState) => state.cart.salesTaker || '';

export const getSalesTakerQuery = (state: PageState) => state.location.search?.salestaker || '';
